import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "package-formula-update"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  key: 0,
  class: "page-header"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("套餐/组方");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_6 = {
  class: "page-body"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("活动设置");

const _hoisted_8 = {
  class: "form-section"
};
const _hoisted_9 = {
  class: "activity-time-range"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "activity-time-separator"
}, "至", -1);

const _hoisted_11 = {
  class: "supplier-publisher-wrap"
};
const _hoisted_12 = {
  class: "product-section"
};
const _hoisted_13 = {
  class: "section-title-row"
};

const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "section-title"
}, "选择商品", -1);

const _hoisted_15 = {
  class: "product-panel"
};
const _hoisted_16 = {
  class: "product-toolbar"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("选择商品");

const _hoisted_18 = {
  class: "package-summary"
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 套餐共计 ");

const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 种商品，套餐价 ");

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 元 ");

const _hoisted_22 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_23 = {
  class: "column-header-tip"
};

const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 套餐单价 ");

const _hoisted_25 = {
  class: "pre-payment-price-cell"
};
const _hoisted_26 = {
  key: 0,
  class: "pre-payment-price-text"
};
const _hoisted_27 = {
  key: 0,
  class: "footer"
};

const _hoisted_28 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_29 = /*#__PURE__*/_createTextVNode("提交并再次新建");

const _hoisted_30 = /*#__PURE__*/_createTextVNode("提交");

const _hoisted_31 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_32 = /*#__PURE__*/_createTextVNode("确定");

import { reactive, computed, ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { QuestionFilled, Edit } from '@element-plus/icons-vue';
import { activityGroupUpdate, getActivityGroupInfo } from '@/request';
import { arrayRemoveRepeatByProp } from '@/utils';
import VanInputSelect from '@/components/input/input-select.vue';
import BranchModal from '../PreferentialPurchase/components/branch-modal.vue';
import SupplierModal from '../PreferentialPurchase/components/muti-supplier-modal.vue';
import MerchandiseModal from './components/merchandise-modal.vue';
import PrePaymentPriceModal from './components/pre-payment-price-modal.vue';
import { createEmptyPrePaymentPrices, formatPrePaymentPriceRange, hasCompletePrePaymentPrices, pickPrePaymentPrices, PRE_PAYMENT_PRICE_FIELDS } from './components/pre-payment-price-constants';
export default {
  name: 'activity-update',
  props: {
    embedMode: {
      type: Boolean,
      default: false
    },
    embedSnapshot: {
      type: Object,
      default: null
    }
  },

  setup(__props) {
    const props = __props;
    const route = useRoute();
    const router = useRouter();
    const {
      pageType = 'create'
    } = route.query;
    onMounted(() => {
      if (props.embedMode) {
        return;
      }

      if (['update', 'view', 'copy'].includes(pageType) && route.query.activityId) {
        getDetail();
      }
    });
    const pageTitle = {
      create: '新建',
      update: '编辑',
      view: '查看',
      copy: '复制'
    };
    const updateDisabled = computed(() => props.embedMode || pageType === 'view');
    const loading = ref(false);
    const submitting = ref(false);
    const form = ref();
    const editRemarkDialog = reactive({
      visible: false,
      remark: '',
      submitType: undefined
    });

    class FormDataTpl {
      constructor() {
        this.activityId = undefined;
        this.activityName = '';
        this.activityTimeList = [];
        this.supplierInfoVo = {
          supplierId: undefined,
          supplierName: ''
        };
        this.branchInfoVo = {
          branchId: undefined,
          branchName: ''
        };
        this.activityMerchandiseInfoList = [];
      }

    }

    const formData = reactive(new FormDataTpl());
    const activityStartTime = computed({
      get: () => {
        var _formData$activityTim, _formData$activityTim2;

        return (_formData$activityTim = (_formData$activityTim2 = formData.activityTimeList) === null || _formData$activityTim2 === void 0 ? void 0 : _formData$activityTim2[0]) !== null && _formData$activityTim !== void 0 ? _formData$activityTim : null;
      },
      set: val => {
        var _formData$activityTim3, _formData$activityTim4;

        formData.activityTimeList = [val, (_formData$activityTim3 = (_formData$activityTim4 = formData.activityTimeList) === null || _formData$activityTim4 === void 0 ? void 0 : _formData$activityTim4[1]) !== null && _formData$activityTim3 !== void 0 ? _formData$activityTim3 : null];
      }
    });
    const activityEndTime = computed({
      get: () => {
        var _formData$activityTim5, _formData$activityTim6;

        return (_formData$activityTim5 = (_formData$activityTim6 = formData.activityTimeList) === null || _formData$activityTim6 === void 0 ? void 0 : _formData$activityTim6[1]) !== null && _formData$activityTim5 !== void 0 ? _formData$activityTim5 : null;
      },
      set: val => {
        var _formData$activityTim7, _formData$activityTim8;

        formData.activityTimeList = [(_formData$activityTim7 = (_formData$activityTim8 = formData.activityTimeList) === null || _formData$activityTim8 === void 0 ? void 0 : _formData$activityTim8[0]) !== null && _formData$activityTim7 !== void 0 ? _formData$activityTim7 : null, val];
      }
    });

    const activityTimeDisabledDate = date => {
      const oneDayTimeStamp = 24 * 60 * 60 * 1000;
      return new Date(date).getTime() + oneDayTimeStamp < Date.now();
    };

    const formRules = {
      activityName: [{
        required: true,
        message: '请填写活动名称',
        trigger: 'blur'
      }],
      activityTimeList: [{
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          const startTime = value === null || value === void 0 ? void 0 : value[0];
          const endTime = value === null || value === void 0 ? void 0 : value[1];

          if (!startTime || !endTime) {
            callback(new Error('请选择活动时间'));
            return;
          }

          if (pageType === 'create' && new Date(startTime).getTime() <= Date.now()) {
            callback(new Error('活动开始时间不得小于当前时间'));
            return;
          }

          if (new Date(endTime).getTime() <= new Date(startTime).getTime()) {
            callback(new Error('活动结束时间不得小于活动开始时间'));
            return;
          }

          callback();
        }
      }],
      supplierInfoVo: [{
        required: true,
        trigger: '',
        validator: (rule, value, callback) => {
          if (!(value !== null && value !== void 0 && value.supplierId)) {
            callback(new Error('请选择活动发起方'));
            return;
          }

          callback();
        }
      }],
      branchInfoVo: [{
        required: true,
        trigger: '',
        validator: (rule, value, callback) => {
          if (!(value !== null && value !== void 0 && value.branchId)) {
            callback(new Error('请选择活动发货方'));
            return;
          }

          callback();
        }
      }],
      activityMerchandiseInfoList: [{
        required: true,
        trigger: 'submit',
        validator: (rule, value, callback) => {
          if (!(value !== null && value !== void 0 && value.length)) {
            callback(new Error('请添加活动商品'));
            return;
          }

          const invalid = value.some(item => !item.groupNum || item.groupNum <= 0);

          if (invalid) {
            callback(new Error('请填写商品数量'));
            return;
          }

          const priceInvalid = value.some(item => !item.salePrice || item.salePrice <= 0);

          if (priceInvalid) {
            callback(new Error('请填写套餐单价'));
            return;
          }

          const prePaymentInvalid = value.some(item => !hasCompletePrePaymentPrices(item));

          if (prePaymentInvalid) {
            callback(new Error('请维护套餐预付单价'));
            return;
          }

          callback();
        }
      }]
    };
    const merchandiseCount = computed(() => formData.activityMerchandiseInfoList.length);
    const packagePriceText = computed(() => {
      if (!formData.activityMerchandiseInfoList.length) {
        return '-';
      }

      const total = formData.activityMerchandiseInfoList.reduce((sum, item) => {
        const price = Number(item.salePrice) || 0;
        const qty = Number(item.groupNum) || 0;
        return sum + price * qty;
      }, 0);
      return total.toFixed(2);
    });

    function goBack() {
      router.replace({
        name: route.query.from || 'PackageFormula'
      });
    }

    const branchModal = reactive({
      visible: false
    });
    const supplierModal = reactive({
      visible: false,
      selectedSupplierIds: []
    });
    const merchandiseModal = reactive({
      visible: false
    });
    const prePaymentPriceModal = reactive({
      visible: false,
      prodNo: undefined,
      priceData: createEmptyPrePaymentPrices()
    });
    watch(() => props.embedSnapshot, val => {
      if (props.embedMode && val) {
        applyDetailData(val);
      }
    }, {
      immediate: true
    });
    const supplierPublisherCount = computed(() => {
      var _supplierModal$select, _formData$supplierInf;

      if ((_supplierModal$select = supplierModal.selectedSupplierIds) !== null && _supplierModal$select !== void 0 && _supplierModal$select.length) {
        return supplierModal.selectedSupplierIds.length;
      }

      const supplierId = (_formData$supplierInf = formData.supplierInfoVo) === null || _formData$supplierInf === void 0 ? void 0 : _formData$supplierInf.supplierId;

      if (!supplierId) {
        return 0;
      }

      return String(supplierId).split(',').filter(id => id).length;
    });
    const supplierInputDisplay = computed(() => {
      const count = supplierPublisherCount.value;

      if (count > 1) {
        return `已选择${count}个团队`;
      }

      return formData.supplierInfoVo.supplierName || '';
    });
    const selectedMerchandiseProdNos = computed(() => formData.activityMerchandiseInfoList.map(item => item.prodNo));

    function openSupplierModalHandle() {
      supplierModal.visible = true;
    }

    function selectBranchHandle() {
      if (!formData.supplierInfoVo.supplierId) {
        ElMessage.warning('请先选择活动发起方');
        return false;
      }

      branchModal.visible = true;
    }

    function selectBranchSuccessHandle(branchRow) {
      if (!branchRow) {
        return;
      }

      const {
        branchId,
        branchName
      } = branchRow;
      formData.branchInfoVo = {
        branchId,
        branchName
      };
    }

    function selectSupplierSuccessHandle(supplierRows) {
      if (!(supplierRows !== null && supplierRows !== void 0 && supplierRows.length)) {
        return;
      }

      const supplierRowsList = [...supplierRows].sort((a, b) => a.supplierId - b.supplierId);
      const supplierId = supplierRowsList.map(supplier => supplier.supplierId).join(',');
      const supplierName = supplierRowsList.map(supplier => supplier.supplierName).join(',');
      formData.supplierInfoVo = {
        supplierId,
        supplierName
      };
      supplierModal.selectedSupplierIds = supplierRowsList.map(supplier => supplier.supplierId);
    }

    function supplierClearHandle() {
      formData.supplierInfoVo = {
        supplierId: undefined,
        supplierName: ''
      };
      supplierModal.selectedSupplierIds = [];
      formData.branchInfoVo = {
        branchId: undefined,
        branchName: ''
      };
      formData.activityMerchandiseInfoList = [];
    }

    function branchClearHandle() {
      formData.branchInfoVo = {
        branchId: undefined,
        branchName: ''
      };
      formData.activityMerchandiseInfoList = [];
    }

    function addMerchandiseHandle() {
      if (!formData.supplierInfoVo.supplierId || !formData.branchInfoVo.branchId) {
        ElMessage.warning('请先选择活动发起方和活动发货方');
        return false;
      }

      merchandiseModal.visible = true;
    }

    function normalizeMerchandiseItem(item) {
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, item), createEmptyPrePaymentPrices()), pickPrePaymentPrices(item)), {}, {
        groupNum: item.groupNum != null ? Number(item.groupNum) : 1,
        salePrice: item.salePrice != null ? Number(item.salePrice) : undefined
      });
    }

    function openPrePaymentPriceModal(row) {
      prePaymentPriceModal.prodNo = row.prodNo;
      prePaymentPriceModal.priceData = pickPrePaymentPrices(row);
      prePaymentPriceModal.visible = true;
    }

    function prePaymentPriceSuccessHandle(priceData) {
      const index = formData.activityMerchandiseInfoList.findIndex(item => item.prodNo === prePaymentPriceModal.prodNo);

      if (index > -1) {
        Object.assign(formData.activityMerchandiseInfoList[index], pickPrePaymentPrices(priceData));
      }
    }

    function selectMerchandiseSuccessHandle(merchandiseList) {
      if (!(merchandiseList !== null && merchandiseList !== void 0 && merchandiseList.length)) {
        return;
      }

      const list = [...formData.activityMerchandiseInfoList, ...merchandiseList];
      const uniqueList = arrayRemoveRepeatByProp(list, 'prodNo');
      formData.activityMerchandiseInfoList = uniqueList.map(normalizeMerchandiseItem);
    }

    function deleteMerchandiseHandle(scope) {
      const {
        prodNo
      } = scope.row;
      const deleteIndex = formData.activityMerchandiseInfoList.findIndex(v => v.prodNo === prodNo);

      if (deleteIndex > -1) {
        formData.activityMerchandiseInfoList.splice(deleteIndex, 1);
      }
    }

    function showSubmitValidateError(message) {
      if (!message) {
        return;
      }

      ElMessage.error({
        message,
        duration: 5000,
        showClose: true
      });
    }

    function applyDetailData(data) {
      if (!data) {
        return;
      }

      const {
        activityId,
        activityName,
        activityStartTime,
        activityEndTime,
        supplierInfoVo,
        branchInfoVo,
        activityMerchandiseInfoList
      } = data;
      formData.activityId = props.embedMode || pageType !== 'copy' ? activityId : undefined;
      formData.activityName = activityName;
      formData.activityTimeList = [activityStartTime, activityEndTime];

      if (supplierInfoVo) {
        formData.supplierInfoVo = {
          supplierId: supplierInfoVo.supplierIds || supplierInfoVo.supplierId,
          supplierName: supplierInfoVo.supplierName || ''
        };
        supplierModal.selectedSupplierIds = String(supplierInfoVo.supplierIds || supplierInfoVo.supplierId || '').split(',').filter(id => id);
      }

      formData.branchInfoVo = branchInfoVo || {
        branchId: undefined,
        branchName: ''
      };
      formData.activityMerchandiseInfoList = (activityMerchandiseInfoList || []).map(normalizeMerchandiseItem);
    }

    function getDetail() {
      loading.value = true;
      getActivityGroupInfo({
        activityId: route.query.activityId
      }).then(res => {
        applyDetailData(res.data);
      }).finally(() => {
        loading.value = false;
      });
    }

    function submit(type) {
      form.value.validate((valid, invalidFields) => {
        if (!valid) {
          var _invalidFields$firstP, _invalidFields$firstP2;

          const props = Object.keys(invalidFields || {});
          const firstProp = props[0];
          const firstMsg = firstProp ? (_invalidFields$firstP = invalidFields[firstProp]) === null || _invalidFields$firstP === void 0 ? void 0 : (_invalidFields$firstP2 = _invalidFields$firstP[0]) === null || _invalidFields$firstP2 === void 0 ? void 0 : _invalidFields$firstP2.message : '';
          showSubmitValidateError(firstMsg || '请完善活动表单必填项');
          return false;
        }

        if (pageType === 'update') {
          editRemarkDialog.submitType = type;
          editRemarkDialog.remark = '';
          editRemarkDialog.visible = true;
          return true;
        }

        doSubmit(type);
        return true;
      });
    }

    function confirmEditRemarkSubmit() {
      var _editRemarkDialog$rem;

      if (submitting.value) {
        return;
      }

      const remark = (_editRemarkDialog$rem = editRemarkDialog.remark) === null || _editRemarkDialog$rem === void 0 ? void 0 : _editRemarkDialog$rem.trim();

      if (!remark) {
        ElMessage.warning('请输入更新备注');
        return;
      }

      editRemarkDialog.visible = false;
      doSubmit(editRemarkDialog.submitType, remark);
    }

    function doSubmit(type, editRemark) {
      if (submitting.value) {
        return;
      }

      submitting.value = true;
      const body = {
        activityId: pageType === 'update' ? formData.activityId : undefined,
        activityName: formData.activityName,
        activityStartTime: formData.activityTimeList[0],
        activityEndTime: formData.activityTimeList[1],
        supplierInfoVo: {
          supplierIds: formData.supplierInfoVo.supplierId
        },
        branchInfoVo: {
          branchId: formData.branchInfoVo.branchId,
          branchName: formData.branchInfoVo.branchName
        },
        activityMerchandiseInfoList: formData.activityMerchandiseInfoList.map(item => {
          const payload = {
            prodNo: item.prodNo,
            prodName: item.prodName,
            prodSpecification: item.prodSpecification,
            packageUnit: item.packageUnit,
            manufacturer: item.manufacturer,
            groupNum: item.groupNum,
            salePrice: item.salePrice
          };
          PRE_PAYMENT_PRICE_FIELDS.forEach(field => {
            payload[field] = item[field];
          });
          return payload;
        })
      };

      if (pageType === 'update' && editRemark) {
        body.editRemark = editRemark;
      }

      body.__repeat = true;
      activityGroupUpdate(body).then(res => {
        const {
          success,
          msg
        } = res;

        if (success) {
          if (type === 'refresh') {
            Object.assign(formData, new FormDataTpl());
            supplierModal.selectedSupplierIds = [];
            form.value.resetFields();
            ElMessage.success('提交成功，创建的活动已提交成功，请继续创建');
          } else {
            ElMessage.success(msg || '操作成功');
            goBack();
          }

          return true;
        }

        showSubmitValidateError(msg);
        return false;
      }).finally(() => {
        submitting.value = false;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_divider = _resolveComponent("el-divider");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_link = _resolveComponent("el-link");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!__props.embedMode ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(pageTitle[_unref(pageType)]) + "套餐活动", 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_button, {
        icon: "Back",
        type: "primary",
        link: "",
        onClick: goBack
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_form, {
        ref_key: "form",
        ref: form,
        model: formData,
        rules: formRules,
        "label-position": "right",
        "label-width": "100px",
        class: "activity-form"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_form_item, {
          label: "活动名称",
          prop: "activityName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formData.activityName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.activityName = $event),
            placeholder: "如：迪巧儿童套餐，最多15个字",
            class: "form-control",
            disabled: _unref(updateDisabled),
            maxlength: 15,
            "show-word-limit": ""
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动时间",
          prop: "activityTimeList"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_date_picker, {
            modelValue: _unref(activityStartTime),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(activityStartTime) ? activityStartTime.value = $event : null),
            type: "datetime",
            placeholder: "开始日期",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            "disabled-date": activityTimeDisabledDate,
            disabled: _unref(updateDisabled)
          }, null, 8, ["modelValue", "disabled"]), _hoisted_10, _createVNode(_component_el_date_picker, {
            modelValue: _unref(activityEndTime),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(activityEndTime) ? activityEndTime.value = $event : null),
            type: "datetime",
            placeholder: "结束日期",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            "disabled-date": activityTimeDisabledDate,
            disabled: _unref(updateDisabled)
          }, null, 8, ["modelValue", "disabled"])])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动发起方",
          prop: "supplierInfoVo"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(VanInputSelect, {
            "model-value": _unref(supplierInputDisplay),
            disabled: _unref(updateDisabled),
            class: "form-control publisher-input",
            onSelect: openSupplierModalHandle,
            onClear: supplierClearHandle
          }, null, 8, ["model-value", "disabled"]), _unref(supplierPublisherCount) > 1 ? (_openBlock(), _createBlock(_component_el_link, {
            key: 0,
            type: "primary",
            underline: false,
            class: "supplier-publisher-count",
            onClick: openSupplierModalHandle
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(supplierPublisherCount)) + "个团队", 1)]),
            _: 1
          })) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "活动发货方",
          prop: "branchInfoVo"
        }, {
          default: _withCtx(() => [_createVNode(VanInputSelect, {
            modelValue: formData.branchInfoVo.branchName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.branchInfoVo.branchName = $event),
            disabled: _unref(updateDisabled),
            class: "form-control branch-input",
            onSelect: selectBranchHandle,
            onClear: branchClearHandle
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        })]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_divider, {
          "content-position": "left"
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        })]), _createVNode(_component_el_form_item, {
          prop: "activityMerchandiseInfoList",
          "label-width": "0",
          class: "product-form-item"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [!_unref(updateDisabled) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            plain: "",
            onClick: addMerchandiseHandle
          }, {
            default: _withCtx(() => [_hoisted_17]),
            _: 1
          })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_18, [_hoisted_19, _createElementVNode("em", null, _toDisplayString(_unref(merchandiseCount)), 1), _hoisted_20, _createElementVNode("em", null, _toDisplayString(_unref(packagePriceText)), 1), _hoisted_21])]), _createVNode(_component_el_table, {
            data: formData.activityMerchandiseInfoList,
            border: "",
            class: "product-table",
            "empty-text": "暂无数据"
          }, {
            default: _withCtx(() => [!_unref(updateDisabled) ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "操作",
              width: "80",
              fixed: "left"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: $event => deleteMerchandiseHandle(scope)
              }, {
                default: _withCtx(() => [_hoisted_22]),
                _: 2
              }, 1032, ["onClick"])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
              prop: "prodNo",
              label: "商品编码",
              width: "180",
              "show-overflow-tooltip": ""
            }), _createVNode(_component_el_table_column, {
              prop: "prodName",
              label: "商品名称",
              width: "180",
              "show-overflow-tooltip": ""
            }), _createVNode(_component_el_table_column, {
              prop: "prodSpecification",
              label: "规格",
              width: "120",
              "show-overflow-tooltip": ""
            }), _createVNode(_component_el_table_column, {
              prop: "packageUnit",
              label: "单位",
              width: "60",
              "show-overflow-tooltip": ""
            }), _createVNode(_component_el_table_column, {
              prop: "manufacturer",
              label: "厂家",
              width: "200",
              "show-overflow-tooltip": ""
            }), _createVNode(_component_el_table_column, {
              label: "数量",
              width: "180"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row.groupNum,
                "onUpdate:modelValue": $event => scope.row.groupNum = $event,
                min: 0.01,
                max: 999999999,
                precision: 2,
                disabled: _unref(updateDisabled),
                "controls-position": "right",
                class: "table-input-number"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "销售价",
              width: "140",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.retailPrice || ''), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              width: "180"
            }, {
              header: _withCtx(() => [_createVNode(_component_el_tooltip, {
                content: "套餐价=套餐单价×数量",
                placement: "top"
              }, {
                default: _withCtx(() => [_createElementVNode("span", _hoisted_23, [_hoisted_24, _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(QuestionFilled))]),
                  _: 1
                })])]),
                _: 1
              })]),
              default: _withCtx(scope => [_createVNode(_component_el_input_number, {
                modelValue: scope.row.salePrice,
                "onUpdate:modelValue": $event => scope.row.salePrice = $event,
                min: 0.01,
                max: 999999999,
                precision: 2,
                disabled: _unref(updateDisabled),
                "controls-position": "right",
                class: "table-input-number"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              label: "套餐预付单价",
              width: "200"
            }, {
              default: _withCtx(scope => [_createElementVNode("div", _hoisted_25, [_unref(formatPrePaymentPriceRange)(scope.row) ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(formatPrePaymentPriceRange)(scope.row)), 1)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
                type: "primary",
                link: "",
                onClick: $event => openPrePaymentPriceModal(scope.row)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(Edit))]),
                  _: 1
                })]),
                _: 2
              }, 1032, ["onClick"])])]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])])]),
          _: 1
        })])]),
        _: 1
      }, 8, ["model"])])]), !__props.embedMode && !_unref(updateDisabled) ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_el_button, {
        onClick: goBack
      }, {
        default: _withCtx(() => [_hoisted_28]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        loading: submitting.value,
        disabled: submitting.value,
        onClick: _cache[4] || (_cache[4] = $event => submit('refresh'))
      }, {
        default: _withCtx(() => [_hoisted_29]),
        _: 1
      }, 8, ["loading", "disabled"]), _createVNode(_component_el_button, {
        type: "primary",
        loading: submitting.value,
        disabled: submitting.value,
        onClick: submit
      }, {
        default: _withCtx(() => [_hoisted_30]),
        _: 1
      }, 8, ["loading", "disabled"])])) : _createCommentVNode("", true), _createVNode(BranchModal, {
        modelValue: branchModal.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => branchModal.visible = $event),
        supplierId: formData.supplierInfoVo.supplierId,
        onSuccess: selectBranchSuccessHandle
      }, null, 8, ["modelValue", "supplierId"]), _createVNode(SupplierModal, {
        modelValue: supplierModal.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => supplierModal.visible = $event),
        selectedSupplierIds: supplierModal.selectedSupplierIds,
        checkType: "checkbox",
        onSuccess: selectSupplierSuccessHandle
      }, null, 8, ["modelValue", "selectedSupplierIds"]), _createVNode(MerchandiseModal, {
        modelValue: merchandiseModal.visible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => merchandiseModal.visible = $event),
        branchId: formData.branchInfoVo.branchId,
        supplierIds: formData.supplierInfoVo.supplierId,
        selectedList: _unref(selectedMerchandiseProdNos),
        onSuccess: selectMerchandiseSuccessHandle
      }, null, 8, ["modelValue", "branchId", "supplierIds", "selectedList"]), _createVNode(PrePaymentPriceModal, {
        modelValue: prePaymentPriceModal.visible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => prePaymentPriceModal.visible = $event),
        "price-data": prePaymentPriceModal.priceData,
        disabled: _unref(updateDisabled),
        onSuccess: prePaymentPriceSuccessHandle
      }, null, 8, ["modelValue", "price-data", "disabled"]), _createVNode(_component_el_dialog, {
        modelValue: editRemarkDialog.visible,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => editRemarkDialog.visible = $event),
        title: "活动更新备注",
        width: "480px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => editRemarkDialog.visible = false)
        }, {
          default: _withCtx(() => [_hoisted_31]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: submitting.value,
          disabled: submitting.value,
          onClick: confirmEditRemarkSubmit
        }, {
          default: _withCtx(() => [_hoisted_32]),
          _: 1
        }, 8, ["loading", "disabled"])]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: editRemarkDialog.remark,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => editRemarkDialog.remark = $event),
          type: "textarea",
          rows: 4,
          maxlength: 255,
          "show-word-limit": "",
          placeholder: "请输入本次活动更新备注"
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, loading.value]]);
    };
  }

};